import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const SlidersAdd = () => {
  const [slideImage, setSlideImage] = useState(null);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleAddNewSliders = () => {
    navigate("/add-sliders");
  };

  const handleViewAllSliders = () => {
    navigate("/all-sliders");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!slideImage) {
      alert("Please upload a slider image.");
      return;
    }

    const formData = new FormData();
    formData.append("slideImage", slideImage);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/admin/slides`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      alert("Slider uploaded successfully.");
      navigate("/all-sliders");
    } catch (error) {
      console.error("Error uploading slider:", error);
      alert("Failed to upload slider. Please try again.");
    }
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Add Slider</h5>
          <div className="subjectdiv2">
            <button className="handleNewSubject" onClick={handleAddNewSliders}>
              + Add New Slider
            </button>
            <button className="allSubjects" onClick={handleViewAllSliders}>
              All Sliders
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Slider Details</h4>
          <form
            className="subject-detail-form"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Upload Slider</label>
              </div>
              <input
                type="file"
                id="subject-upload-icon"
                multiple={false}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setSlideImage(file);
                  }
                }}
              />
            </div>

            <div className="school-subj-form-btns">
              <button className="btn-search" type="submit">
                Save
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={() => navigate("/all-sliders")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SlidersAdd;
